<template>
  <div class="container">
    <div class="product-list" v-show="productList.length > 0">
      <div class="list" v-for="(item,index) in productList" @click="goTaskDetail(item)">
        <div class="product-img">
          <img class="pro-icon" src="../../../static/image/hallNoSubmit/task.png" v-if="item.missionType == '1'" alt/>
          <img class="pro-icon" src="../../../static/image/hallNoSubmit/zijian.png" v-if="item.missionType == '2'" alt/>

          <img class="product-img-border" :src="item.squarePicture" v-if="item.missionType == '1'" alt />
          <img class="product-img-border" src="../../../static/image/recommendIcon.png" v-if="item.missionType == '2'" alt />
        </div>
        <div class="product-detail">
          <div class="pro-title">{{item.missionName}}</div>
          <div class="pro-text">
            <div class="pro-time">
              <div class>活动时间</div>
              <div class>起 {{item.missionStartTime}}</div>
              <div class>止 {{item.missionEndTime}}</div>
            </div>
            <div v-if="item.taskStatus=='0'" class="submit">已结束</div>
            <div v-if="item.taskStatus=='1'" :class="item.canSubmit==2 ? 'submit':'submit-no'">去提交</div>
            <div v-if="item.taskStatus=='2'" class="submit">评审中</div>
            <div v-if="item.taskStatus=='3'" class="submit">待签约</div>
            <div v-if="item.taskStatus=='4'" class="submit">待结算</div>
            <img src="../../../static/image/hallNoSubmit/taskFanish.png" v-if="item.taskStatus=='5'" />
          </div>
        </div>
      </div>
    </div>
    <div v-show="productList.length == 0" class="product-list">
      <div style="width: 100%">
        <img style="width: 20%;margin-left: 40%;margin-top: 10%" src="../../../static/image/hallNoSubmit/nodata.png" alt/>
        <div style="width: 20%;height:40px;line-height:40px;margin-left: 40%;text-align: center;color:#CCCCCC;margin-top: 40px;">暂无数据</div>
      </div>

    </div>
    <!-- 引入分页器 -->
    <div class="PagePagination">
      <PagePagination ref="PageFrom" :pageIndex="pageIndex" :pageSize="pageSize"
                      :queryType="queryType" :val="val" :total="total"></PagePagination>
    </div>
  </div>
</template>

<script>
  import config from "../../api/config";
  import PagePagination from "../../components/pagePagination/pagePagination"; //引入分页器

  export default {
    name: "productHallList",
    props: ["region","queryType","val"],
    components:{
      PagePagination
    },
  // ,"pageIndex","pageSize","queryType","val"

    data() {
      return {
        productList: [],
        pageIndex: 1,
        pageSize: 10,
        total:0,
        isTrue:false
      };
    },
    watch:{
      isTrue(n,o){
        console.log(n,o)
        this.isTrue = 0
      }
    },
    created() {
      this.getProductList();

    },
    methods: {
      changePageIndex(page) {
        this.pageIndex = page;
        this.isTrue = false
        setTimeout(() => {
          this.getProductList()
        }, 100)
      },
      //获取设计列表
      async getProductList() {
        try {
            if(this.isTrue){
              this.pageIndex = 1
            }
            console.log(this.pageIndex,this.isTrue,"this.isTrue")

           console.log(this.pageIndex,"this.isTrue")
          let data = {
            lastId: this.lastId,
            pageIndex:this.pageIndex,
            pageSize: this.pageSize,
            queryType: this.queryType,
            val: this.val,
          }
          const res = await this.$http.getTaskList(data)
          if (res.code == 200) {
            if(res.result){
              res.result.records.forEach((item)=>{
                item.squarePicture = item.squarePicture&&(item.squarePicture.indexOf("http")>-1||item.squarePicture.indexOf("https")>-1)?
                item.squarePicture:item.squarePicture==null?"../../../static/image/recommendIcon.png":config.baseImgUrl+item.squarePicture
              })
              this.productList = res.result.records;
              console.log(this.productList)
              this.total = res.result.total
              this.$parent.changePageInfo(res.result.current,res.result.size,res.result.total)
            }else{
              this.productList = [];
            }
          } else {
            // this.$message(res.message);
          }
        } catch (e) {

          throw e
        }
      },
      //进入详情
      goTaskDetail(record) {
        console.log(record);
        let taskstatus = record.taskStatus;
        if (record.canSubmit == 2) {
        this.$router.push({
          path: "/hall/hallDetail",
          query: { id: record.id },
        });
      }else if(record.canSubmit == 1) {
        this.$message('不在任务时间内，无法提交');
      } else {
        this.$message('该任务已截止无法提交');
      }
        // if(taskstatus=='1'){
        //   //    待提交，跳转到去提交
        //   this.$router.push({
        //     path: "/hall/hallDetail",
        //     query: {id:record.id},
        //   });
        // }else if(taskstatus=='0' || taskstatus=='2'){
        //   //    跳转评审中
        //   this.$router.push({
        //     path: "/hall/reviceDetail",
        //     query: {id:record.id},
        //   });
        // }else if(taskstatus=='3' || taskstatus=='4' || taskstatus=='5'){
        //   // 跳转待签约
        //   this.$router.push({
        //     path: "/hall/signDetail",
        //     query: {id:record.id},
        //   });
        // }
      },
    },
  };
</script>


<style scoped>
  .container {
    width: 100%;
  }

  .product-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    min-height: 700px;
  }

  .list {
    width: 18%;
    margin: 21px 1% 0 1%;
    display: inline-block;
    background: #ffffff;
    border-radius: 5px;
    height: 0%;
  }

  .product-img {
    width: 100%;
  }

  .product-img img {
    width: 100%;
    /*height: 220px;*/
  }
  .product-img-border{
    border-radius: 8px 8px 0 0;
  }
  .pro-icon {
    width: 46px !important;
    height: 22px !important;
    position: absolute;
  }

  .product-detail {
    padding: 0 8px 18px 8px;
  }

  .pro-title {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #3a3a3a;
    opacity: 1;
    margin: 15px 0 0 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  .pro-text {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .pro-text img {
    width: 50px;
    height: 50px;
    margin: 11px 0 0 0;
  }

  .pro-time {
    font-size: 8px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 14px;
    color: #9e9e9e;
    opacity: 1;
    margin: 15px 0 0 0;
  }

  .submit {
    width: 62px;
    height: 24px;
    background: #dfb876;
    opacity: 1;
    border-radius: 14px;
    text-align: center;
    font-size: 11px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 23px;
    color: #ffffff;
    opacity: 1;
    margin: 31px 0 0 0;
  }
  .submit-no {
  width: 62px;
  height: 24px;
  background: #cfcfce;
  opacity: 1;
  border-radius: 14px;
  text-align: center;
  font-size: 11px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 23px;
  color: #ffffff;
  opacity: 1;
  margin: 31px 0 0 0;
}
  .PagePagination {
    width: 63%;
    margin: 56px 18.5% 0px 18.5%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/productList/productHallList.vue